export default "__VITE_ASSET__a62b38dd__"